'use strict';

var MarketTDChartPOSFilterFactory = function MarketTDChartPOSFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketTDChartPOSFilter() {
    DemandFilter.call(this, 'market', 'thematic-demand-chart-market-pos');
    this.registerFilters(injectedFilters);
  }
  MarketTDChartPOSFilter.constructor = MarketTDChartPOSFilter;
  MarketTDChartPOSFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketTDChartPOSFilter;
};
MarketTDChartPOSFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketTDChartPOSFilterFactory;